<template>
    <div>
        <site-header></site-header>
        <forgotten-password-form></forgotten-password-form>
        <site-footer></site-footer>
    </div>
</template>
<script>
import ForgottenPasswordForm from "./components/organisms/OrganismForgottenPasswordForm.vue";
import SiteFooter from "./components/organisms/OrganismSiteFooter.vue";
import SiteHeader from "./components/organisms/OrganismSiteHeader.vue";

export default {
    components: {
        SiteHeader,
        ForgottenPasswordForm,
        SiteFooter
    },
    metaData() {
        return {
            title: "Glömt lösenordet?",
            meta: [
                {
                    vmid: "description",
                    name: "description",
                    content:
                        "Om du har glömt ditt lösenord kan du få det skickat till dig via e-post. Fyll i formuläret nedan så löser vi resten."
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: `${process.env.SITE_BASE_URL}${this.$route.path}`
                }
            ]
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/views/ForgottenPassword.vue